import _ from 'lodash';
import { BaseDto } from '../../../base.dto';
import { InspectionCase } from '../../inspection-cases/inspection-case.dto';
import { InspectionValueCase } from '../../inspection-cases/inspection-value-case.dto';
import { Inspection } from '../../inspection.dto';

export class ActivationRegimeEventDto {
  name?: string;
  actions: { name: string; isPassed?: boolean | null }[];
}

export class ActivationRegimeActionsDto {
  alerts: string[];
  smoke: string[];
  fireSeperation: string[];
  systems: string[];
}

export class ActivationRegimeDto extends BaseDto {
  actions: ActivationRegimeActionsDto;
  events: ActivationRegimeEventDto[];
}

export class ActivationRegimeCaseDto extends InspectionValueCase {
  actions: ActivationRegimeActionsDto;
  events: ActivationRegimeEventDto[];
}

export class ActivationRegime extends ActivationRegimeCaseDto {
  constructor(obj?: ActivationRegimeCaseDto) {
    super(obj);
    this.title = 'משטר הפעלות';
    this.isApplicable = true;
    this.events = obj?.events || [];
    this.actions = obj?.actions || {
      alerts: [],
      smoke: [],
      fireSeperation: [],
      systems: []
    };
  }

  setInspectionStatus() {
    this.isPassed = this._isPassed();
  }

  _isPassed(): boolean {
    const eventsStatusesArr = _.flatMap(this.events, (event) =>
      _.map(event.actions, 'isPassed')
    );

    return !eventsStatusesArr.some((x) => x === false);
  }
}

export class ActivationRegimeCase extends InspectionCase implements Inspection {
  data: ActivationRegime[];

  constructor(obj: ActivationRegimeCase = { data: [] }) {
    super(obj);

    this.data = obj.data
      ? obj.data.map((item) => new ActivationRegime(item))
      : [new ActivationRegime()];
  }

  setInspectionStatus?(): void {
    this.data.forEach((x) => x.setInspectionStatus());
    this.isPassed = !this.isApplicable || this._isPassed();
  }

  private _isPassed?(): boolean {
    return !this.data.some((x) => !x.isPassed);
  }
}
